import { ThemeProvider } from "./theme/ThemeProvider";
import { SessionProvider, useSession } from "./features/session/SessionContext";
import {
  ConnectingScreen,
  ErrorScreen,
  NoSessionScreen,
} from "./features/session/SessionScreens";
import { ChatApp } from "./features/ChatApp";

function SessionGate() {
  const session = useSession();

  switch (session.phase) {
    case "connecting":
      return <ConnectingScreen />;
    case "no-session":
      return <NoSessionScreen />;
    case "error":
      return <ErrorScreen message={session.error ?? "Unknown error"} />;
    case "ready":
      if (session.client && session.accessToken) {
        return <ChatApp client={session.client} accessToken={session.accessToken} />;
      }
      return <ErrorScreen message="Session is missing required credentials." />;
    default:
      return <NoSessionScreen />;
  }
}

export default function App() {
  return (
    <ThemeProvider>
      <SessionProvider>
        <SessionGate />
      </SessionProvider>
    </ThemeProvider>
  );
}
